import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.8411 13.0101L17.2011 8.3601C16.8987 8.08179 16.4335 8.08179 16.1311 8.3601L11.5211 13.0101C11.333 13.3002 11.3676 13.6813 11.6049 13.9328C11.8421 14.1843 12.2205 14.241 12.5211 14.0701L15.7411 10.8501V19.7501C15.7411 20.1643 16.0769 20.5001 16.4911 20.5001C16.9053 20.5001 17.2411 20.1643 17.2411 19.7501V10.5601L20.7511 14.0701C21.0439 14.3626 21.5183 14.3626 21.8111 14.0701C22.112 13.7856 22.1254 13.3111 21.8411 13.0101Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.5213 9.22C11.2285 8.92755 10.7541 8.92755 10.4613 9.22L7.27129 12.44V3.75C7.27129 3.33579 6.93551 3 6.52129 3C6.10708 3 5.77129 3.33579 5.77129 3.75V12.75L2.26129 9.22C1.96578 8.94464 1.50528 8.95277 1.21967 9.23838C0.934059 9.52399 0.925934 9.98449 1.20129 10.28L5.84129 14.93C6.13753 15.2236 6.61505 15.2236 6.91129 14.93L11.5213 10.28C11.8137 9.98718 11.8137 9.51282 11.5213 9.22Z",
		fill: "currentColor"
	})]
});
export default SvgSort;
